module.exports = __webpack_public_path__ + "media/gai12-2.0cd71fb5.mp3";